import gql from "graphql-tag";

export const SEARCH_USERS = gql`
    query SearchUsers($name: String) {
        users(username: $name) {
            id
            username
        }
    }
`;

export const SEARCH_ASSIGNABLE_USERS = gql`
    query AssignableUsers($name: String, $taskId: ID!) {
        task(id: $taskId) {
            assignableUsers(username: $name) {
                id
                username
            }
        }
    }
`;

export const GET_TASK_PERMISSIONS = gql`
    query GetTaskPermissions {
        permissions {
            task {
                canViewAllOpen
                canAssign
                canEditDispositionComments
            }
        }
    }
`;

export const ASSIGN_MUTATION = gql`
    mutation AssignTask($taskId: Int!, $userId: Int!) {
        assignTask(taskId: $taskId, userId: $userId) {
            ... on ClaimTaskSuccess {
                task {
                    id
                    uid
                    owner {
                        id
                        username
                    }
                }
            }
        }
    }
`;

export const TASKS_QUERY = gql`
    query TasksQuery(
        $taskType: TaskType!
        $taskName: String
        $taskStatus: String
        $countryCode: String
        $linesOfBusiness: [String]
        $linesOfBusinessSearchOperator: String
        $entityName: String
        $processName: String
        $count: Int!
        $cursor: String
        $createdAfter: Date
        $createdBefore: Date
        $ordering: [String]
        $ownerIds: [Int]
    ) {
        tasks(
            taskType: $taskType
            taskName: $taskName
            taskStatus: $taskStatus
            countryCode: $countryCode
            linesOfBusiness: $linesOfBusiness
            linesOfBusinessSearchOperator: $linesOfBusinessSearchOperator
            entityName: $entityName
            processName: $processName
            createdAfter: $createdAfter
            createdBefore: $createdBefore
            first: $count
            after: $cursor
            ordering: $ordering
            ownerIds: $ownerIds
        ) @connection(key: "TasksSearchTable_tasks") {
            edges {
                node {
                    id
                    uid
                    title
                    priority
                    created
                    status
                    assignable
                    process: rootProcess {
                        id
                        title
                    }
                    owner {
                        id
                        username
                    }
                    properties {
                        edges {
                            node {
                                id
                                name
                                value
                            }
                        }
                    }

                    entity {
                        id
                        key {
                            ulid
                        }
                        name
                        entityType(returnMode: NAME)
                        registrationStatus(returnMode: LABEL)
                        activeProcesses
                        legalAddress {
                            countryCode
                        }
                        physicalAddress {
                            countryCode
                        }
                        createdDate
                        additionalProperties
                        monitoring
                        linesOfBusiness
                        riskLevel(returnMode: LABEL)
                    }
                }
                cursor
            }
            pageInfo {
                totalCount
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_LOBS = gql`
    query LinesOfBusinessQuery {
        linesOfBusiness
    }
`;
